module.exports = __webpack_public_path__ + "img/sys3.561deb77.png";